

export function changeLanguagePref(i18nInstance, language){
    i18nInstance.changeLanguage(language)
    window.localStorage.setItem("language", language)
}

export function getLanguagePref(){
    return window.localStorage.getItem("language")
}

export function getLanguageString(language){
    if(language.includes("en")) {
        return "简体中文"
    } else {
        return "English"
    }
}

export function getLanguagesByCountry(country) {
    switch(country){
        case "us":
            return [
                {
                    value: "fr-US",
                    display_name: "Français"
                },
                {
                    value: "en-US",
                    display_name: "English"
                },
                {
                    value: "zh-US",
                    display_name: "简体中文"
                }
            ]
        default: 
            return [
                {
                    value: "fr-CA",
                    display_name: "Français"
                },
                {
                  value: "en-CA",
                  display_name: "English"
                },
                {
                  value: "zh-CA",
                  display_name: "简体中文"
                }
            ]
    }
}